var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var fieldset = {
    alignItems: 'start',
    border: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    margin: 0,
    padding: 0,
};
export var label = {
    alignItems: 'center',
    boxSizing: 'border-box',
    padding: "".concat(8, "px ").concat(12, "px ").concat(8, "px 0"),
    color: '#000000',
    display: 'flex',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: "".concat(24, "px"),
};
export var innerWrapper = {
    display: 'flex',
    ':hover': {
        input: {
            background: '#E5EFFF',
        },
    },
};
export var innerWrapperChecked = __assign(__assign({}, innerWrapper), { ':hover': {
        input: {
            background: '#1454CC',
        },
    } });
/** @ignore */
export var labelWidth = function (column) { return ({
    width: column === undefined ? 'auto' : Math.floor(100 / column) + '%',
}); };
export var col1 = labelWidth(1);
export var col2 = labelWidth(2);
export var col3 = labelWidth(3);
export var col4 = labelWidth(4);
export var col6 = labelWidth(6);
export var inputWrapper = {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    marginRight: 12,
};
export var input = {
    appearance: 'none',
    backgroundColor: '#ffffff',
    margin: 0,
    height: '24px',
    width: '24px',
    border: "1px solid ".concat('#7E8A94'),
    borderRadius: '50%',
    transition: '120ms background ease-in-out, 120ms border ease-in-out',
    ':disabled': {
        background: "".concat('#DFE4E8', " !important"),
        border: "1px solid ".concat('#A8B2BA', " !important"),
        cursor: 'not-allowed',
    },
    ':focus': {
        boxShadow: "0 0 0 2px ".concat('#ffffff', ", 0 0 0 4px ").concat('#1454CC'),
    },
};
export var inputChecked = __assign(__assign({}, input), { backgroundColor: '#1454CC', ':focus': {
        boxShadow: "0 0 0 2px ".concat('#ffffff', ", 0 0 0 4px ").concat('#1454CC'),
    } });
export var styledInput = {
    background: '#ffffff',
    borderRadius: '50%',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    fontSize: '16px',
    justifyContent: 'center',
    transform: 'scale(0)',
    transition: '120ms transform ease-in-out',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '24px',
    width: '24px',
};
export var styledInputChecked = {
    transform: 'scale(0.4)',
};
export var styledInputDisabled = {
    background: '#b7c0c9',
};
export var textWrapperDisabled = {
    color: '#8E9AA3',
    cursor: 'not-allowed',
};
